module.exports = __webpack_public_path__ + "img/metamask.bca3db3e.png";